
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Icons / arrow-curve-down-left","xmlns":"http://www.w3.org/2000/svg","width":"24.521","height":"21.358"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Combined Shape","d":"M5.093 21.01L.348 16.264l-.116-.134a1.187 1.187 0 01.115-1.545l.134-.115a1.187 1.187 0 011.545.115l2.719 2.719v-6.625l.007-.374A10.678 10.678 0 0115.425 0h7.911l.164.011a1.187 1.187 0 01-.161 2.362h-7.79l-.463.007a8.3 8.3 0 00-7.963 8.3v6.628l2.717-2.722.132-.115a1.187 1.187 0 011.545 1.794L6.772 21.01a1.192 1.192 0 01-.128.11 1.187 1.187 0 01-1.545-.115z","fill":"#17a398"}})])
          )
        }
      }
    